export enum OrganizationGroupCodesDto {
  LASY = 'LASY',
}
